
import { computed, defineComponent, reactive } from 'vue';
import { IOptionString } from '@/core/models/AntDesign/IOption';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';
import { useTelaBase } from '@/core/composables/TelaBase';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import ServicoUtilitario from '@/servicos/MeuSistema/ServicoUtilitario';

export default defineComponent({
  name: 'SelecionarGenero',
  props: {
    varios: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: String || undefined,
    },
    codigosSelecionados: {
      type: Array as () => string[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Digite para selecionar',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados', 'change'],
  setup(props, { emit }) {
    const { montaOpcoesComListaItemGenericoTexto } = useTelaBase();

    let debounce = 0;
    const servicoUtilitario = new ServicoUtilitario();

    const state = reactive({
      listaGeneroItens: [] as IOptionString[],
      buscandoDados: false,
      emDigitacao: false,
    });

    async function obterGeneroPorCodigo(valor: any) {
      if (state.emDigitacao) { return; }
      if (!UtilitarioGeral.valorValido(valor)) { return; }

      if (props.varios) {
        if (props.codigosSelecionados.length === 0) { return; }
      } else if (props.codigoSelecionado === '') {
        return;
      }
      let efetuarConsulta = true;

      if (UtilitarioGeral.validaLista(state.listaGeneroItens)) {
        if (props.varios) {
          const listaCodigosConsulta = state.listaGeneroItens.map((c) => c.value);
          const diferencas = props.codigosSelecionados.filter((c) => !listaCodigosConsulta.includes(c));
          if (!UtilitarioGeral.validaLista(diferencas)) {
            efetuarConsulta = false;
          }
        } else {
          const existeLista = state.listaGeneroItens.find((c) => c.value === props.codigoSelecionado);
          if (existeLista !== undefined) {
            efetuarConsulta = false;
          }
        }
      }

      if (!efetuarConsulta) return;

      state.listaGeneroItens = [];

      const parametrosConsultaRapida: IParametrosConsultaRapida = {
        apenasAtivos: false, recursoAssociado: '',
      };

      if (props.varios) {
        parametrosConsultaRapida.filtrarPorVariosCodigos = true;
        parametrosConsultaRapida.valores = valor;
      } else {
        parametrosConsultaRapida.filtrarPorCodigo = true;
        parametrosConsultaRapida.valor = valor;
      }

      const listaGeneroItens = await servicoUtilitario.consultaGeneroItem(valor);
      state.listaGeneroItens = montaOpcoesComListaItemGenericoTexto(listaGeneroItens);
      if (!UtilitarioGeral.validaLista(listaGeneroItens)) {
        if (props.varios) {
          emit('update:codigosSelecionados', undefined);
        } else {
          emit('update:codigoSelecionado', undefined);
        }
      }
    }

    async function pesquisarGenero(valorPesquisa: any) {
      state.emDigitacao = true;

      state.buscandoDados = true;
      state.listaGeneroItens = [];
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        const listaGeneroItens = await servicoUtilitario.consultaGeneroItem(valorPesquisa);
        state.buscandoDados = false;
        state.listaGeneroItens = montaOpcoesComListaItemGenericoTexto(listaGeneroItens);
      }, 600);
    }

    function obterGenero():any {
      obterGeneroPorCodigo(props.codigoSelecionado);
      return props.codigoSelecionado;
    }

    const computedCodigoSelecionado = computed({
      get: () => obterGenero(),
      set: (val: number) => {
        emit('update:codigoSelecionado', val);
      },
    });

    function obterGeneroItens():string[] {
      obterGeneroPorCodigo(props.codigosSelecionados);
      return props.codigosSelecionados;
    }

    const computedCodigosSelecionados = computed({
      get: () => obterGeneroItens(),
      set: (val: string[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    function change() {
      emit('change', props.varios ? props.codigosSelecionados : props.codigoSelecionado);
    }

    return {
      props,
      state,
      pesquisarGenero,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
      change,
    };
  },
});
